import React from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import * as apiUrl from "../../apiUrl";

const BlogDiscription = ({
  title,
  description,
  postingDate,
  place,
  centerImage,
}) => {
  return ( 
      <section className="latest-blog-sec">
        <Container fluid>
          <Row className="flex-center">
            <Col md={10} className="padding-zero">
              <div className="latest-blog-content-div" data-aos="fade-up">
                <h2 className="common-head">{title}</h2>
                <Col md={12} className="padding-zero">
                  <img
                    src={`${apiUrl.apiUrl}/${centerImage}`}
                    className="img-fluid mb-4"
                    alt="Premium properties Dubai"
                  />
                </Col>
                <p className="common-para goldenColor">
                  Date:{place} {postingDate}
                </p>
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </div>
            </Col>
          </Row>
        </Container>
      </section> 
  );
};

export default BlogDiscription;
